<!--- //
服务器配置管理
@auth xuyd
// -->
<template>
  <page-layout layout="C">
    <IndexPageableTree v-if="true"/>
    <IndexVxe v-if="false"/>
    <IndexMultiselect v-if="false"/>
    <IndexSingleselect v-if="false"/>
  </page-layout>
</template>
<script>
import IndexPageableTree from "./index-pageableTree";
import IndexVxe from "./index-vxe";
import IndexMultiSelect from "./index_multiselect";
import IndexSingleSelect from "./index_singleselect";

export default {
  name: 'ViewTableList',
  components: {IndexPageableTree, IndexVxe, IndexMultiSelect, IndexSingleSelect}
}
</script>
